import { gql } from '@apollo/client';

export const getTermsAndConditionsAdditional = gql`
 query getTermsAndConditionsFromFiles($id: String!) {
  getTermsAndConditionsFromFiles(id: $id) {
    brandName
    brandCode
    logoUrl
    documents {
      fileId
      fileName
    }
  }
}
  `;
